mutation RemoveExternalMeeting($input: RemoveExternalMeetingInput!) {
    removeExternalMeeting(input: $input) {
        externalMeeting {
            id
        }
    }
}
